import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from 'src/@shared/common-pages.service';
import { ResponseStatus, ValidationMessage } from 'src/@shared/enum';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import data from 'src/assets/json/states.json';
@Component({
  selector: 'add-update-site-preferred-partners',
  templateUrl: './add-update-site-preferred-partners.component.html',
  styleUrls: ['./add-update-site-preferred-partners.component.scss'],

  standalone: false,
})
export class AddUpdateSitePreferredPartnersComponent implements OnInit {
  sitesData: any = [];
  isVisiblePreferredPartnersDrawer = true;
  isLoadingOne: any = false;
  LineStreetAddress: any = false;
  preferredPartnerDrawerTitle: any;
  @Output() hidePreferredPartnerDrawer = new EventEmitter();
  @Input() selectedPreferredPartnerData: any;
  @Input() selectedSiteId: any;
  listOfStates: any = data.States;
  validationMessage = ValidationMessage;
  selectedUnits: any[] = [];
  passwordVisible = false;
  pageSize: number = 10;
  @ViewChild('zipcode') zipcode: any;
  isAddAddressClicked: boolean = false;

  constructor(
    public _cs: CommonService,
    private _ws: CommonPagesService,
    public _fS: FormService,
    private _wss: InnerPagesService
  ) {
    _fS.preferredPartnerForm_fb();
  }
  ngOnInit(): void {
    //while edit change modal title
    this.selectedPreferredPartnerData != null
      ? (this.preferredPartnerDrawerTitle = 'Edit Preferred Partners')
      : (this.preferredPartnerDrawerTitle = 'Add New Preferred Partners');
    if (this.selectedPreferredPartnerData != null) {
      this.preferredPartnerDrawerTitle = 'Edit Preferred Partners';
      // this._fS.preferredPartnerForm.patchValue({
      //   labelName: this.selectedPreferredPartnerData.labelName,
      //   programStartMonth: this.selectedPreferredPartnerData.programStartMonth,
      //   programStartYear: this.selectedPreferredPartnerData.programStartYear,
      //   programEndMonth: this.selectedPreferredPartnerData.programEndMonth,
      //   programEndYear: this.selectedPreferredPartnerData.programEndYear,
      //   ispreferredPartnerActive: this.selectedPreferredPartnerData.ispreferredPartnerActive,
      // });
    } else {
      this.preferredPartnerDrawerTitle = 'Add New Preferred Partners';
    }
  }
  //close drawer
  handleCancel() {
    this.isVisiblePreferredPartnersDrawer = false;
    this.hidePreferredPartnerDrawer.emit({
      hide: this.isVisiblePreferredPartnersDrawer,
      data: null,
    });
  }
  preventDefaults(event: any) {
    event.preventDefault();
    return false;
  }
  //add or update button of drawer clicked
  handleOk() {
    if (this._fS.preferredPartnerForm.valid) {
      const formValue = this._fS.preferredPartnerForm.value;
      var preferredPartnerBody: any = {
        siteId: this.selectedSiteId,
        companyName: formValue.companyName,
        investorDisplayName: formValue.customerDisplayName,
        email: formValue.emailAddress,
        phoneNumber: formValue.phoneNumber,
        streetAddress1: formValue.address1,
        streetAddress2: formValue.address2,
        city: formValue.city,
        state: formValue.state,
        zipCode: formValue.zipcode,
        country: formValue.country,
        isAddLine: this.LineStreetAddress,
      };
      this.addPartnersData(preferredPartnerBody);
    } else {
      //to fire validations on invalid fields
      Object.values(this._fS.preferredPartnerForm.controls).forEach(
        (control: any) => {
          if (control.invalid) {
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
        }
      );
    }
  }

  //add or update date on buttton click
  addPartnersData(preferredPartnerBody: any) {
    this.isLoadingOne = true;
    this._ws.addPPartners(preferredPartnerBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cs.displayMessage('success', response.message);
          //hide unit drawer
          this.isVisiblePreferredPartnersDrawer = false;
          this.hidePreferredPartnerDrawer.emit({
            hide: this.isVisiblePreferredPartnersDrawer,
            data: response.result,
          });
          this.isLoadingOne = false;
        } else {
          this._cs.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        // this._cs.displayMessage('error', error.message);
        this.isLoadingOne = false;
      }
    );
  }

  broofa() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  focusZipCode(event) {
    if (event) {
      this.zipcode.first.nativeElement.focus();
    }
  }
  addLines(event: any) {
    this.LineStreetAddress = event;
    this._fS.preferredPartnerForm.patchValue({
      address1:
        this._fS.preferredPartnerForm.get('address1').value != null &&
        this._fS.preferredPartnerForm.get('address1').value != ''
          ? this._fS.preferredPartnerForm.get('address1').value +
            '\r\n' +
            this._fS.preferredPartnerForm.get('address2').value
          : this._fS.preferredPartnerForm.get('address2').value,
      address2: '',
    });
  }

  addAddressPartner(event: boolean) {
    this.isAddAddressClicked = event;
  }

  addPreferredPartnerAddress(event: any) {
    this.LineStreetAddress = event;
    if (this.LineStreetAddress) {
      const form = this._fS.preferredPartnerForm.value;

      const address =
        (form.address1?.trim() ? form.address1.trim() + '\n' : '') +
        (form.address2?.trim() ? form.address2.trim() + '\n' : '') +
        (form.city?.trim() ? form.city.trim() + ', ' : '') +
        (form.state?.trim() ? form.state.trim() + ' ' : '') +
        (form.zipcode?.trim() ? form.zipcode.trim() + '\n' : '') +
        (form.address1?.trim() ||
        form.address2?.trim() ||
        form.city?.trim() ||
        form.state?.trim() ||
        form.zipcode?.trim()
          ? form.country
          : '');

      this._fS.preferredPartnerForm.patchValue({
        address1: address,
        address2: '',
        city: '',
        state: '',
        zipcode: '',
        country: '',
      });
    } else {
      this._fS.preferredPartnerForm.patchValue({
        address1: '',
        country: 'USA',
      });
    }
  }
}
